export default __webpack_public_path__ + "static/media/pdf-icon.cb797456.svg";